// Autocomplete du plan de comptes (/api/accounts/search), partagé par le menu
// de reclassification et la ventilation bancaire : même debounce, même cache.

import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./api";

export interface AccountRow {
  code: string;
  label: string;
  type?: string;
  parentCode?: string | null;
}

const LIMIT = 30;

export function useAccountSearch(query: string, { enabled = true }: { enabled?: boolean } = {}) {
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  // Debounce 200 ms pour ne pas spammer l'API
  useEffect(() => {
    const t = setTimeout(() => setDebouncedQuery(query), 200);
    return () => clearTimeout(t);
  }, [query]);

  const { data, isPending } = useQuery<{ accounts: AccountRow[] }>({
    queryKey: ["accounts-search", debouncedQuery],
    queryFn: () => apiGet(`/api/accounts/search?q=${encodeURIComponent(debouncedQuery)}&limit=${LIMIT}`),
    enabled,
    // Court : des comptes naissent côté serveur (paie, régénération) sans invalidation.
    staleTime: 10_000,
  });
  return { accounts: data?.accounts ?? [], isPending: enabled && isPending, debouncedQuery };
}
